import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { RoomDirectoryComponent } from './room-directory/room-directory.component';
import { AdminEventComponent } from './admin-event/admin-event.component';
import { EventsAndHearingsComponent } from './events-and-hearings/events-and-hearings.component';
import { DirectionsComponent } from './directions/directions.component';

const routes: Routes = [
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'directory',
    component: RoomDirectoryComponent
  },
  {
    path: 'events-and-hearings',
    component: EventsAndHearingsComponent
  },
  {
    path: 'admin-events',
    component: AdminEventComponent,
    data: { disableIdleRedirect: true }
  },
  {
    path: 'directions',
    component: DirectionsComponent
  },
  {
    path: 'directions/:room/:userMemberCode',
    component: DirectionsComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
